import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, photoUrl } from "@/lib/api";

export default function Matches() {
  const [rows, setRows] = useState([]);
  useEffect(() => { (async () => { const { data } = await api.get("/matches"); setRows(data); })(); }, []);

  return (
    <div className="min-h-screen bg-dc-gradient p-4">
      <div className="max-w-3xl mx-auto">
        <div className="flex items-center justify-between">
          <h1 className="font-display text-2xl font-extrabold">Your matches</h1>
          <Link to="/dashboard" className="text-sm text-purple-200 hover:text-white">← Dashboard</Link>
        </div>
        {rows.length === 0 ? (
          <div className="glass rounded-3xl p-8 mt-6 text-center text-purple-200/70">No matches yet.</div>
        ) : (
          <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 gap-4">
            {rows.map((r) => (
              <Link data-testid={`match-item-${r.match.id}`} key={r.match.id} to={`/matches/${r.match.id}`} className="glass rounded-3xl p-4 flex items-center gap-4 hover:bg-purple-900/40">
                <div className="w-16 h-16 rounded-2xl overflow-hidden bg-black/40">
                  {r.other?.photo_ids?.[0] && <img src={photoUrl(r.other.photo_ids[0])} className="w-full h-full object-cover" alt="" />}
                </div>
                <div>
                  <div className="font-bold">{r.other?.display_name}</div>
                  <div className="text-xs text-purple-200/70">{r.other?.age} · {r.other?.city}</div>
                </div>
              </Link>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
